module.exports = __webpack_public_path__ + "img/img_nav_logout-w.c51ea4b5.svg";